import React, { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { HelpCircle } from "lucide-react";

// Cache the lexicon in module scope
let _cache = null;
async function loadLexicon() {
  if (_cache) return _cache;
  try {
    const r = await axios.get(`${API}/lexicon`);
    _cache = r.data.terms;
    return _cache;
  } catch { return {}; }
}

export default function TermTooltip({ term, children, size = 11 }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (open && !data) {
      loadLexicon().then((all) => setData(all[term]));
    }
  }, [open, data, term]);

  return (
    <span className="relative inline-flex items-center gap-1 group">
      {children}
      <button
        type="button"
        className="inline-flex items-center text-white/40 hover:text-accent-blue transition-colors"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        aria-label={`Explication ${term}`}
        data-testid={`tooltip-${term}`}
      >
        <HelpCircle size={size} />
      </button>
      {open && data && (
        <span className="absolute z-50 left-1/2 -translate-x-1/2 top-6 w-72 p-3 rounded-md border border-white/15 bg-card shadow-xl text-left animate-in fade-in duration-100">
          <span className="block font-heading text-[13px] text-white mb-1">
            <span className="font-mono text-accent-blue">{data.acronym}</span> — {data.name}
          </span>
          <span className="block text-[11px] text-white/60 mb-1.5 italic">{data.family}</span>
          <span className="block text-[12px] text-white/85 leading-relaxed">{data.easy}</span>
          <span className="block text-[11px] text-white/40 mt-2">→ Voir onglet Lexique pour les détails techniques.</span>
        </span>
      )}
    </span>
  );
}
